// v20-R1 R15: de NL-datum als YYYY-MM-DD, uit de losse delen (niet afhankelijk van hoe een engine "en-CA" opmaakt).
export function datumNL(d = new Date()) {
  const p = Object.fromEntries(new Intl.DateTimeFormat("nl-NL", { timeZone: "Europe/Amsterdam", year: "numeric", month: "2-digit", day: "2-digit" })
    .formatToParts(d).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}`;
}
